module.exports = __webpack_public_path__ + "img/childrenIocn.2012638a.png";